import customAxios from "../../customAxios";
import {ACCEPT_MANY_PAY_TO_DRIVER, REJECT_MANY_PAY_TO_DRIVER, SUB_LOGIN} from "../../routes";

type Props = {
  withdrawalId: string[];
};

const rejectManyPayToDriver = async (props: Props) => {
  try {
    return (
      await customAxios.put(REJECT_MANY_PAY_TO_DRIVER , {
        withdrawalId: props.withdrawalId,
      })
    ).data;
  } catch (error: unknown) {
    console.error({REJECT_MANY_PAY_TO_DRIVER: error});
    return false;
  }
};

export default rejectManyPayToDriver;
